// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import {InitialLoadingScreenClass} from './initial_loading_screen_class';

const InitialLoadingScreen = new InitialLoadingScreenClass();

export default InitialLoadingScreen;
